module.exports = __webpack_public_path__ + "static/media/PC4-1.792c0cc0.jpeg";